import { render } from "./NotFoundPage.vue?vue&type=template&id=59acdc6a"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=59acdc6a&scooped=true&lang=css"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__